<div class="stat-card" [ngClass]="'stat-card--' + variant">
  <div class="stat-card-top">
    <span class="stat-card-label">{{ label }}</span>
    @if (icon) {
      <span class="stat-card-icon">
        @switch (icon) {
          @case ('check') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="9"></circle>
              <polyline points="8.5 12.5 11 15 16 9.5"></polyline>
            </svg>
          }
          @case ('pause') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="9"></circle>
              <line x1="10" y1="9" x2="10" y2="15"></line>
              <line x1="14" y1="9" x2="14" y2="15"></line>
            </svg>
          }
          @case ('users') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          }
          @case ('card') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2"></rect>
              <line x1="1" y1="10" x2="23" y2="10"></line>
            </svg>
          }
        }
      </span>
    }
  </div>
  <div class="stat-card-value">{{ value ?? 0 }}</div>
</div>
